import React from 'react';
import Button from './ui/Button';
import SectionWrapper from './ui/SectionWrapper';

const stripItemClass =
  'font-medium text-gray-600 whitespace-nowrap';

export default function HeroSection({ onNavigate, audience = 'all' }) {
  const creatorVariant = audience === 'producer' ? 'outline' : 'primary';
  const recruiterVariant = audience === 'producer' ? 'primary' : 'outline';

  return (
    <SectionWrapper className="mt-10 text-center">
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-gray-900">
        <span className="italic text-[#C8A75B]">Empowering</span>{' '}
        <span>Creators,</span>
        <br />
        <span>Professionals</span> &amp; <span>Innovators</span>
      </h1>

      <p className="mx-auto mt-4 max-w-2xl text-base sm:text-lg text-gray-600 leading-relaxed">
        Learn. Certify. Build your portfolio.
        <br />
        Connect with production houses, get funded and launch a career in
        Media &amp; Entertainment.
      </p>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
        {/* Primary CTA */}
        <Button
          type="button"
          variant={creatorVariant}
          onClick={() => onNavigate(audience === 'producer' ? '/profiles' : '/profile')}
          className="px-8 py-3 shadow-sm"
        >
          I&apos;m a creator
        </Button>

        {/* Outlined CTA */}
        <Button
          type="button"
          variant={recruiterVariant}
          onClick={() => onNavigate('/profiles')}
          className="px-8 py-3"
        >
          I&apos;m a recruiter
        </Button>
      </div>

      {/* Horizontal scrolling strip */}
      <div className="mt-10 overflow-x-auto">
        <div className="flex items-center gap-3 px-2 pb-2">
          {[
            'Upskill & Certify',
            'Source Talent',
            'Build Portfolio',
            'Find Studios & Locations',
            'Screen Stories with AI',
          ].map((t, idx) => (
            <React.Fragment key={t}>
              <span className={stripItemClass}>{t}</span>
              {idx !== 4 && <span className="text-gray-400">•</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}

